import WebSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-web.mdx";
import IdentifiedVsAnonymousIntro from "../../../../contents/docs/product-analytics/_snippets/identified-vs-anonymous-intro.mdx";
import HowToCaptureAnonymousEventsWeb from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-web.mdx";
import HowToCaptureIdentifiedEventsWeb from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-frontend.mdx";
import JSIdentify from "../../../../contents/docs/libraries/js/_snippets/identify.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import WebFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-web.mdx";
import BootstrappingIntro from "../../../../contents/docs/feature-flags/snippets/bootstrapping-intro.mdx";
import * as React from 'react';
export default {
  WebSendEvents,
  IdentifiedVsAnonymousIntro,
  HowToCaptureAnonymousEventsWeb,
  HowToCaptureIdentifiedEventsWeb,
  JSIdentify,
  FeatureFlagsLibsIntro,
  WebFeatureFlagsCode,
  BootstrappingIntro,
  React
};